// src/components/pages/UniversityCourse/index.jsx

import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Skeleton } from "antd";
import API from "API";
import { NotFound } from "AppRoute";
import TermHandle from "./TermHandle";
import PathTabs from "components/general/PathTabs";
import { UserOutlined } from "@ant-design/icons"
import BasicInfo from "./BasicInfo";
import LessonList from "./LessonList";

const UniversityCourse = () => {
    const { id } = useParams();

    const [course, setCourse] = useState(null);
    const [loadingCourse, setLoadingCourse] = useState(true);

    // Load course details and list of courses for prerequisites
    const loadCourse = useCallback(async () => {
        try {
            setLoadingCourse(true);
            const res = await API.get(`/courses/${id}/`);
            res.data.required_courses = res.data.required_courses.map((item) => item.id);
            setCourse(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingCourse(false);
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            loadCourse();
        }
    }, [id, loadCourse]);


    if (loadingCourse) return <Skeleton active />;
    if (!course) return <NotFound />;

    return (
        <>
            <h4>{course.name}</h4>
            <p>{course.description}</p>

            <PathTabs 
                basePath={`/university-courses/${id}`}
                titlePath={course.name}
                items={[
                    {
                        label: <><UserOutlined style={{ marginRight: 4 }} />Thông tin cơ bản</>,
                        key: "information",
                        children: <BasicInfo course={course} setCourse={setCourse} />
                    },
                    {
                        label: <><UserOutlined style={{ marginRight: 4 }} />Quản lý kỳ học</>,
                        key: "term-handle",
                        children: <TermHandle course={course} />
                    },
                    {
                        label: <><UserOutlined style={{ marginRight: 4 }} />Quản lý bài học</>,
                        key: "lessons",
                        children: <LessonList course={course} loadCourse={loadCourse} />
                    },
                ]}
            />
        </>
    );
};

export default UniversityCourse;
